var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.typePage === 'All')?[_c('OrderLogistic',{ref:"OrderLogisticViewComponent"})]:_vm._e(),_vm._v(" "),_c('router-view',{on:{"allOrdersUpdater":_vm.allOrdersUpdater}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }